/**
 * Color Configuration for Multi-Tenant Support
 * These colors can be overridden per tenant/seller
 */

export const defaultTheme = {
  // Primary Colors
  primary: "#FFC533",
  primaryHover: "#F5B823",
  
  // Secondary Colors
  secondary: "#092A4C",
  secondaryLight: "#4B684F",
  
  // Accent Colors
  accent: "#F26250",
  accentLight: "#F7D5CF",
  
  // Success
  success: "#27AE60",
  successLight: "#2ECC71",
  
  // Neutral Colors
  background: "#FFFFFF",
  surface: "#EEEFE6",
  surfaceAlt: "#F7F3EA",
  
  // Text Colors
  text: {
    primary: "#1D1D1D",
    secondary: "#6E6E73",
    tertiary: "#959590",
    light: "#CCCCCC",
    inverse: "#FFFFFF",
  },
  
  // Border Colors
  border: "#E4E0D8",
  borderLight: "#F0EDE6",
  
  // Overlay
  overlay: "rgba(0, 0, 0, 0.5)",
  overlayLight: "rgba(0, 0, 0, 0.2)",
};

export type Theme = typeof defaultTheme;

/**
 * Get theme colors - can be extended to fetch from API based on tenant
 */
export const getTheme = (_tenantId?: string): Theme => {
  void _tenantId;
  // TODO: Fetch tenant-specific theme from backend if tenantId is provided
  return defaultTheme;
};
